var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpera = function SvgOpera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#opera_svg__a)",
    d: "M12 1.5C6.2 1.5 1.5 6.203 1.5 12c0 5.631 4.433 10.227 10 10.488a10.46 10.46 0 0 0 7.498-2.66 7.58 7.58 0 0 1-4.209 1.286c-2.5 0-4.74-1.24-6.245-3.197-1.161-1.37-1.913-3.396-1.964-5.67v-.494c.05-2.273.803-4.3 1.963-5.67 1.507-1.956 3.746-3.196 6.246-3.196 1.538 0 2.978.47 4.208 1.286a10.46 10.46 0 0 0-6.958-2.672h-.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#opera_svg__b)",
    d: "M8.544 6.084C9.507 4.946 10.75 4.26 12.11 4.26c3.057 0 5.534 3.466 5.534 7.74 0 4.275-2.477 7.74-5.534 7.74-1.36 0-2.604-.685-3.567-1.822 1.506 1.956 3.745 3.196 6.246 3.196 1.538 0 2.976-.47 4.207-1.286a10.47 10.47 0 0 0 3.502-7.827c0-3.11-1.353-5.905-3.501-7.827a7.58 7.58 0 0 0-4.208-1.287c-2.5 0-4.74 1.24-6.246 3.197Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "opera_svg__a",
    x1: 10.249,
    x2: 10.249,
    y1: 1.843,
    y2: 22.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "opera_svg__b",
    x1: 15.521,
    x2: 15.521,
    y1: 3.043,
    y2: 21.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B4B"
  })))));
};
export default SvgOpera;